export enum UploadType {
  EVIDENCE = 'evidence',
  RESOURCE_ATTACHMENT = 'resource-attachment',
  USER_UPLOAD = 'user-upload',
  VIDEO = 'video',
  LOG = 'log',
}
